import React, { useEffect, useState } from "react";
import { ReactComponent as PlayIcon } from "../../icons/play.svg";
import { ReactComponent as PauseIcon } from "../../icons/pause.svg";
import { BodyTyp } from "../Typography/Typography";
import { FontWeightEnum, IconSizeEnum } from "../../types/AppTypes";
import { theme } from "../../constants/StyledComponents";
import { Button, ButtonSizes, ButtonVariants } from "../core/Button/Button";
import { StyledCardTime, StyledTime } from "./Timers.styled";

export const Timers = ({ times }: { times: number[] }) => {
  const [selectedTime, setSelectedTime] = useState<number | null>(null);
  const [remaining, setRemaining] = useState<number>(0);
  const [isRunning, setIsRunning] = useState(false);

  const handleTimeClick = (minutes: number) => {
    setSelectedTime(minutes);
    setRemaining(minutes * 60);
    setIsRunning(false);
  };

  const handleStart = () => {
    if (!selectedTime) return;

    if (remaining === 0) {
      setRemaining(selectedTime * 60);
    }

    setIsRunning(true);
  };

  const handlePause = () => setIsRunning(false);

  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  useEffect(() => {
    if (!isRunning || remaining <= 0) return;

    const timer = setInterval(() => {
      setRemaining((r) => {
        if (r <= 1) {
          clearInterval(timer);
          setIsRunning(false);
          return 0;
        }
        return r - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isRunning, remaining]);

  return (
    <StyledTime>
      {times.map((t) => {
        const isSelected = selectedTime === t;
        const formatted = isSelected ? formatTime(remaining) : `${t}m`;
        return (
          <StyledCardTime
            key={t}
            selected={isSelected}
            onClick={() => handleTimeClick(t)}
          >
            <BodyTyp
              variant="1"
              fontWeight={FontWeightEnum.SEMIBOLD}
              color={isSelected ? theme.colors.purple : theme.colors.black}
            >
              {formatted}
            </BodyTyp>
            {isSelected && isRunning && (
              <Button
                icon={<PauseIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  handlePause();
                }}
                variant={ButtonVariants.PRIMARY}
                size={ButtonSizes.SMALL}
                sizeIcon={IconSizeEnum.SMALL}
              />
            )}
            {isSelected && !isRunning && (
              <Button
                icon={<PlayIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleStart();
                }}
                variant={ButtonVariants.PRIMARY}
                size={ButtonSizes.SMALL}
                sizeIcon={IconSizeEnum.SMALL}
              />
            )}
          </StyledCardTime>
        );
      })}
    </StyledTime>
  );
};
